import { render, staticRenderFns } from "./PublicMoneyKindEditDialog.vue?vue&type=template&id=5bdf7aae&"
import script from "./PublicMoneyKindEditDialog.vue?vue&type=script&lang=ts&"
export * from "./PublicMoneyKindEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
